import * as THREE from "three";
import React, { Suspense, useRef } from "react";
import { useLoader } from "@react-three/fiber";
import { PCDLoader } from "three/examples/jsm/loaders/PCDLoader";
import path from "../path";

const mat = new THREE.PointsMaterial({ color: 0x666666, size: 0.01 });

export default function PointCoin(props) {
  const group = useRef();

  const model1 = useLoader(
    PCDLoader,
    path + "/assets/pointcloud/coin-base.pcd"
  );
  const model2 = useLoader(
    PCDLoader,
    path + "/assets/pointcloud/coin-wolf.pcd"
  );

  model1.material = mat;
  model2.material = mat;

  return (
    <group
      ref={group}
      {...props}
      dispose={null}
      scale={[0.05, 0.1, 0.05]}
      position={[0, 0, 0]}
    >
      <primitive object={model1} position={[0, 0, 0]} />
      <primitive object={model2} position={[0, -2, 0]} />
      {/* <mesh>
        <boxBufferGeometry attach="geometry" args={[5,1,5]} />
        <meshBasicMaterial attach="material" color="red" />
      </mesh> */}
    </group>
  );
}
